export const setWizardDataToStorage = (formData: Record<string, any>, aiClassificationJSON: Record<string, any>, brandFetchRes: Record<string, any>) => {
  const data = {
    formData,
    aiClassificationJSON,
    brandFetchRes,
  };

  window.sessionStorage.setItem("wizardData", JSON.stringify(data));
};
